import React from 'react';
import styles from './OptimizationBanner.module.css';

export const OptimizationBanner: React.FC = () => {
  return (
    <div className={styles.banner}>
      <span className={styles.title}>Route optimized automatically</span>
      <span className={styles.text}>
        — Stops are sequenced for maximum efficiency. Follow the order shown below.
      </span>
    </div>
  );
};
